import React from 'react'


export default function CertifiedIcon() {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="20" cy="20" r="20" fill="#4B9B9B" />
            <path
                d="M32 17.5108C32.0045 16.0987 31.5486 14.7237 30.7015 13.5943C29.8544 12.465 28.6623 11.6428 27.3059 11.2527C25.9496 10.8625 24.5032 10.9256 23.1859 11.4324C21.8687 11.9391 20.7526 12.8619 20.0069 14.0608C19.4282 13.1332 18.625 12.3668 17.6717 11.8323C16.7184 11.2978 15.6457 11.0126 14.5529 11.0031C13.4602 10.9936 12.3827 11.26 11.4202 11.7777C10.4577 12.2955 9.64126 13.0478 9.04649 13.9651C8.45172 14.8824 8.09782 15.9349 8.01755 17.0254C7.93728 18.1159 8.13323 19.209 8.58727 20.2035C9.04131 21.1981 9.73876 22.062 10.6151 22.7152C11.4914 23.3685 12.5182 23.79 13.6006 23.9408C13.1219 24.7935 12.9721 25.7921 13.1793 26.7479C13.3866 27.7036 13.9367 28.5503 14.7255 29.1278C15.5144 29.7053 16.4873 29.9736 17.4605 29.882C18.4336 29.7905 19.3395 29.3453 20.0069 28.6308C20.6743 29.3453 21.5802 29.7905 22.5533 29.882C23.5265 29.9736 24.4994 29.7053 25.2883 29.1278C26.0771 28.5503 26.6271 27.7036 26.8344 26.7479C27.0417 25.7921 26.8919 24.7935 26.4132 23.9408C27.963 23.7236 29.382 22.9532 30.4088 21.7715C31.4355 20.5898 32.0006 19.0766 32 17.5108V17.5108ZM10.0127 17.5108C10.0127 16.3173 10.4865 15.1727 11.3299 14.3288C12.1733 13.4849 13.3173 13.0108 14.5101 13.0108C15.7028 13.0108 16.8468 13.4849 17.6902 14.3288C18.5336 15.1727 19.0075 16.3173 19.0075 17.5108V22.0108H14.5101C13.3181 22.0081 12.1757 21.5332 11.3328 20.6898C10.49 19.8465 10.0153 18.7034 10.0127 17.5108V17.5108ZM17.0086 28.0108C16.4785 28.0108 15.9701 27.8001 15.5952 27.425C15.2204 27.0499 15.0098 26.5412 15.0098 26.0108C15.0098 25.4803 15.2204 24.9716 15.5952 24.5966C15.9701 24.2215 16.4785 24.0108 17.0086 24.0108H19.0075V26.0108C19.0075 26.5412 18.7969 27.0499 18.422 27.425C18.0472 27.8001 17.5387 28.0108 17.0086 28.0108ZM23.0052 28.0108C22.475 28.0108 21.9666 27.8001 21.5918 27.425C21.2169 27.0499 21.0063 26.5412 21.0063 26.0108V24.0108H23.0052C23.5353 24.0108 24.0437 24.2215 24.4186 24.5966C24.7934 24.9716 25.004 25.4803 25.004 26.0108C25.004 26.5412 24.7934 27.0499 24.4186 27.425C24.0437 27.8001 23.5353 28.0108 23.0052 28.0108ZM25.5037 22.0108H21.0063V17.5108C21.0063 16.6208 21.2701 15.7507 21.7643 15.0107C22.2584 14.2707 22.9608 13.6939 23.7826 13.3533C24.6044 13.0127 25.5087 12.9236 26.3811 13.0972C27.2535 13.2709 28.0549 13.6995 28.6839 14.3288C29.3128 14.9581 29.7412 15.7599 29.9147 16.6329C30.0882 17.5058 29.9992 18.4106 29.6588 19.2328C29.3184 20.0551 28.7419 20.7579 28.0023 21.2524C27.2627 21.7469 26.3932 22.0108 25.5037 22.0108V22.0108Z"
                fill="white"
            />
        </svg>
    )
}

export function ApprovedIcon() {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="20" cy="20" r="20" fill="#10B981" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.7071 15.2929C27.0976 15.6834 27.0976 16.3166 26.7071 16.7071L18.7071 24.7071C18.3166 25.0976 17.6834 25.0976 17.2929 24.7071L13.2929 20.7071C12.9024 20.3166 12.9024 19.6834 13.2929 19.2929C13.6834 18.9024 14.3166 18.9024 14.7071 19.2929L18 22.5858L25.2929 15.2929C25.6834 14.9024 26.3166 14.9024 26.7071 15.2929Z"
                fill="white"
            />
        </svg>
    )
}

export function UnderReviewIcon() {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="20" cy="20" r="20" fill="#111827" />
            <path
                d="M20 30.5C14.225 30.5 9.5 25.775 9.5 20C9.5 14.225 14.225 9.5 20 9.5C25.775 9.5 30.5 14.225 30.5 20C30.5 25.775 25.775 30.5 20 30.5ZM20 11C15.05 11 11 15.05 11 20C11 24.95 15.05 29 20 29C24.95 29 29 24.95 29 20C29 15.05 24.95 11 20 11Z"
                fill="white"
            />
            <path
                d="M14.75 21.5C15.5784 21.5 16.25 20.8284 16.25 20C16.25 19.1716 15.5784 18.5 14.75 18.5C13.9216 18.5 13.25 19.1716 13.25 20C13.25 20.8284 13.9216 21.5 14.75 21.5Z"
                fill="white"
            />
            <path
                d="M25.25 21.5C26.0784 21.5 26.75 20.8284 26.75 20C26.75 19.1716 26.0784 18.5 25.25 18.5C24.4216 18.5 23.75 19.1716 23.75 20C23.75 20.8284 24.4216 21.5 25.25 21.5Z"
                fill="white"
            />
            <path
                d="M20 21.5C20.8284 21.5 21.5 20.8284 21.5 20C21.5 19.1716 20.8284 18.5 20 18.5C19.1716 18.5 18.5 19.1716 18.5 20C18.5 20.8284 19.1716 21.5 20 21.5Z"
                fill="white"
            />
        </svg>
    )
}

export function ExipiringIcon() {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="20" cy="20" r="20" fill="#F59E0B" />
            <path d="M20.75 15H19.25V21.75H20.75V15Z" fill="white" />
            <path
                d="M20 23.25C19.4 23.25 18.875 23.775 18.875 24.375C18.875 24.975 19.4 25.5 20 25.5C20.6 25.5 21.125 24.975 21.125 24.375C21.125 23.775 20.6 23.25 20 23.25Z"
                fill="white"
            />
            <path
                d="M29.7499 28.5H10.2499C10.0249 28.5 9.7249 28.35 9.5749 28.125C9.4249 27.9 9.4249 27.6 9.5749 27.375L19.3249 8.62495C19.6249 8.09995 20.3749 8.09995 20.6749 8.62495L30.4249 27.375C30.5749 27.6 30.4999 27.9 30.4249 28.125C30.2749 28.35 29.9749 28.5 29.7499 28.5ZM11.5249 27H28.5499L19.9999 10.65L11.5249 27C11.4499 27 11.4499 27 11.5249 27Z"
                fill="white"
            />
        </svg>
    )
}

export function ErrorStateIcon() {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="20" cy="20" r="20" fill="#DB2777" />
            <path d="M13.3999 19.1774V20.8274H26.5998V19.1774H13.3999Z" fill="white" />
            <path
                d="M12.575 12.5754C8.43844 16.712 8.43844 23.288 12.575 27.4246C16.7116 31.5612 23.2877 31.5612 27.4243 27.4246C31.5608 23.288 31.5608 16.712 27.4243 12.5754C23.2877 8.4388 16.7116 8.4388 12.575 12.5754ZM26.3636 26.364C22.8634 29.8641 17.1359 29.8641 13.6357 26.364C10.1355 22.8638 10.1355 17.1362 13.6357 13.636C17.1359 10.1359 22.8634 10.1359 26.3636 13.636C29.8638 17.1362 29.8638 22.8638 26.3636 26.364Z"
                fill="white"
            />
        </svg>
    )
}

export function RevokedIcon() {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="20" cy="20" r="20" fill="#831843" />
            <path d="M20 14H12.5V15.5H20V14Z" fill="white" />
            <path d="M18.5 17H12.5V18.5H18.5V17Z" fill="white" />
            <path d="M15.5 20H12.5V21.5H15.5V20Z" fill="white" />
            <path
                d="M29 27.5H13.55L30.5 10.55L29.45 9.5L27.95 11H11C10.175 11 9.5 11.675 9.5 12.5V24.5H11V12.5H26.45L9.5 29.45L10.55 30.5L12.05 29H29C29.825 29 30.5 28.325 30.5 27.5V15.5H29V27.5Z"
                fill="white"
            />
        </svg>
    )
}
